export default {
    '行情': '行情',
    '了解最新行情和交易大数据': '了解最新行情和交易大数据',
    '热门榜': '热门榜',
    '新币榜': '新币榜',
    '涨幅榜': '涨幅榜',
    '热门合约': '热门合约',
    '交易': '交易',
    '现货交易': '现货交易',
    '币币闪兑': '币币闪兑，快速交易',
    '搜索': '搜索',
    '主流币': '主流币',
    '热门': '热门',
    '合约': '合约',
    '永续': '永续',
    '灵活杠杆': '灵活杠杆，高倍收益',
    '金融业务': '金融业务',
    '店铺展示': "店铺展示",
    '门店编号': "门店编号",
    '城市': "城市",
    '地址': "地址",
    'show1': '到2030年，Crocodile的合作门店数量预计将达到100,000家。',
    'show2': '每家门店都有真实、独立的身份ID，一切真实、有效、公开、透明！',
    'show3': '加密货币×社区服务×合作共赢',
    'show4': 'Crocodile Exchange 合作店计划·打造本地商业新生态',
    '优质项目起飞的地方': '优质项目起飞的地方',
    '解锁潜质代币': '解锁潜质代币',
    '定期挖矿': '定期挖矿',
    '更多个性化选择': '更多个性化选择',
    '暂无数据': '暂无数据',
    '探索数字资产的无限可能': '探索数字资产的无限可能',
    '更多下载选择': '更多下载选择',
    '注册': '注册',
    '开始': '开始',
    "立即注册，免费创建自己的作品集！": "立即注册，免费创建自己的作品集！",
    '布局未来，现在开始': '布局未来，现在开始',
    '邮箱': '邮箱/手机',
    '把握交易良机': '把握交易良机',
    '市场行情': "市场行情",
    "热门衍生品": "热门衍生品",
    "热门代币": "热门代币",
    '主流榜': '主流榜',
    '现货新币榜': '现货新币榜',
    '合约新币榜': '合约新币榜',
    '交易对': '交易对',
    '最新价': '最新价',
    '涨跌幅': '涨跌幅',
    '走势图': "走势图",
    '成交量': '成交量',
    '操作': '操作',
    '待上币种': '待上币种',
    '上线时间': '上线时间',
    '开盘倒计时': '开盘倒计时',
    '已上币种': '已上币种',
    '下载应用': '下载App',
    '随时随地': '随时随地 开启交易',
    '受千万用户信赖的加密货币交易所': '受千万用户信赖的加密货币交易所',
    '强大的交易体验': '强大的交易体验',
    '提供多种加密货币交易': '提供多种加密货币交易，覆盖现货、合约、跟单等多种产品，满足多样化投资需求',
    '全天服务': '7*24小时服务',
    '提供全天候服务': '专业客服24小时在线，提供全天候服务，随时解答用户疑问',
    '安全合规': '安全合规',
    '顶级安全风控体系': '顶级安全风控体系，多地区合规运营，全方位保护用户资产安全。',
    '全球化布局': '全球化布局',
    '值得全球用户信赖': '覆盖全球210+国家和地区，值得全球用户信赖，助您随时随地参与加密货币交易。',
    '多种币种': '多种币种',
    '多种选择': '多种选择',
    '全天交易量': '24小时交易量',
    '注册用户': '注册用户',
    "用户": "用户",
    '覆盖国家及地区': '覆盖国家及地区',
    '立即开启您的加密货币交易之旅': '立即开启您的加密货币交易之旅',
    '即刻开户': '即刻开户',
    '自动创建账户': '邮箱/手机号注册登入后，自动创建账户',
    '钱包充值': '钱包充值',
    '可随时为账户充值': '可随时为账户充值，我们支持主流渠道入金',
    '开始交易': '开始交易',
    '然后开始交易': '选择想要交易的现货币对或合约，然后开始交易',
    '关于我们': '关于我们',
    '关于': '关于',
    '使用者协议': '使用者协议',
    '隐私政策': '隐私政策',
    '支持': '支持',
    '下载': '下载',
    '帮助中心': '帮助中心',
    '买币': '买币',
    '数字货币计算器': '数字货币计算器',
    '购买': '购买',
    '联系我们': '联系我们',
    '社区': '社区',
    '搜寻': '搜寻',
    '此段落内的文章': '此段落内的文章',
    '简介': '简介',
    '更新于': '更新于',
    '我们的愿景': '我们的愿景',
    '核心优势': '核心优势',
    '产品与服务': '产品与服务',
    '我们的使命': '我们的使命',
    'aboutText1': 'Crocodile 交易所是一家全球领先的数字资产交易平台，致力于为全球用户提供安全、高效、透明的加密货币交易服务。作为行业内的创新先锋，Crocodile 采用先进的区块链技术和金融安全体系，确保用户资产安全，同时提供流畅、稳定的交易体验。',
    'aboutText2': 'Crocodile 交易所的愿景是打造全球最值得信赖的数字资产交易生态系统，为用户提供创新、合规、多元化的交易服务，推动区块链技术与数字金融的发展。',
    'aboutText3': '顶级安全防护：采用银行级安全防护体系，多重加密技术与冷热钱包分离机制，保障用户资产安全。',
    'aboutText4': '高效撮合引擎：Crocodile 拥有全球领先的撮合交易系统，支持超高速交易执行，确保交易顺畅无延迟。',
    'aboutText5': '多币种支持：支持比特币（BTC）、以太坊（ETH）、USDT等多种主流及优质创新型数字资产交易。',
    'aboutText6': '全球合规运营：严格遵守各国金融法规，确保交易合规透明，为用户提供合法合规的数字资产交易服务。',
    'aboutText7': '24/7 专业客服：提供全天候多语言客户支持，帮助用户快速解决问题，优化交易体验。',
    'aboutText8': '现货交易：提供主流加密货币交易对，低延迟、高流动性，适合新手与专业交易者。',
    'aboutText9': '合约交易：高杠杆、低滑点，助力用户实现灵活交易策略。',
    'aboutText10': '质押与理财：提供多种收益型产品，帮助用户实现资产增值。',
    'aboutText11': 'API交易：为机构与量化交易者提供高性能API接口，满足专业交易需求。',
    'aboutText12': 'Crocodile 交易所始终坚持“用户至上、安全至上、创新驱动”的核心价值观，为全球数字资产交易者提供一站式解决方案。我们相信，未来的金融体系将由区块链驱动，Crocodile 将持续推动行业发展，为全球用户带来更加公平、高效、透明的数字金融服务。',
    'aboutText13': 'Crocodile 交易所，让未来金融触手可及！',
    '已结束': '已结束',
    '分发总量': '分发总量',
    '个人兑换限额': '个人兑换限额',
    '最小投入量': '最小投入量',
    '兑换价格': '兑换价格',
    'launchpad': "Crocodile Launchpad是一個優質區塊鏈新項目臻選平台，旨在讓用戶能夠在早期階段購買熱門項目代幣。",
    'launchpad1': "EchoLink 是部署在 Solana 區塊鏈上的一種為 DePIN物聯網裝置設計的區塊鏈預言機。它透過獨特的證明機制橋接和擴充套件各種物聯網裝置，透過收集、測量和驗證它們的工作負載，生成可信的資料報告。這些資料使用零知識證明加密，併發送到Oracle 節點，評估每個裝置單元可以獲得的獎勵。EchoLink 還提供了全面的軟體 SDK 和硬體設計組合旨在成為更多 DePIN 專案的基礎設施。",
    'launchpad2': "ACGN Protocol 是一個由 AI 驅動的 Web3 ACGN（動漫、漫畫、遊戲和小說）創作者生態系統。基於開源創作者協議：ACGN Protocol，用戶可以利用我們的 AI 工具從原創 IP 創建衍生內容，促進衍生品和原創之間的 NFT內容網絡連接，並構建一個自下而上的 ACGN 內容創作生態系統。",
    'launchpad3': "MetaExpand，是Universal Metaverse Expansion Protocol的縮寫（代幣名：UMM），是一個通用的元宇宙擴容協議。 MetaExpand是一個元宇宙生態的底層基礎設施，大幅降低公鍊和元宇宙應用之間的技術鴻溝，提供更友好面向元宇宙應用開發的存儲、通訊、隱私、跨鍊和交易的基礎插件和開發標準，讓開發者不必過多考慮底層區塊鏈的技術差異；MetaExpand也會提供元宇宙基礎構件的範式應用，既可以作為公共插件使用，也可以作為快速開發的起點；MetaExpand定位為兼容其它主流公鏈，並為其賦能，擴展並加速其元宇宙生態開發能力。",
    'launchpad4': "PINs是一個內容社交網絡，它使用多角色扮演來創建情節驅動的元宇宙，並將歷史和文化屬性引入社區。在PINs中，有無數的篇章，每個篇章相當於一個虛擬世界，人們可以扮演多種角色並參與各種行為。",
    'Launchpool1': '我的Launchpool',
    'Launchpool2': 'Metaverse HQ (MVHQ)是一個面向遊戲、De-Fi、協議、創作者、NFT/Memecoin社羣以及去中心化生態系統的AI增強型任務協議。MVHQ 已成為鏈上與鏈下獎勵的通用樞紐，為使用者分發了數百萬美元的價值。',
    'Launchpool3': 'REVOX.AI 正在透過其無許可的機器學習基礎設施構建 Web3 的共享 AI 介面，賦能去中心化 AI 應用的開發與創新，推動模組化智慧代理的廣泛應用。 REVOX 的旗艦超級應用——Web3 GPT Lense、智慧錢包和 ReadON DAO 應用，已在全球範圍內吸引了超過 2100 萬使用者。',
    'Launchpool4': 'Cellula 是一個可編程的激勵層，利用虛擬工作量證明（vPOW）機制，通過創新的遊戲化發行方法實現公平的資產分配和流動性引導。該項目得到了 Binance Labs 和 OKX Ventures 的支持。 Cellula 的 vPOW 賦予「BitLife」實體獨特的哈希率，使它們能夠參與一個遊戲化的挖礦過程，產生動態激勵。這種創新的挖礦方式引入了適應性和可編程性，使 Cellula 能夠實現前所未有的公平資產分配和流動性分配引導——這是 EVM 兼容網絡的真正首創。',
    'Launchpool5': '如何参与LBank Launchpool',
    '全部': '全部',
    '报名中': '报名中',
    '预热中': '预热中',
    '待发放': '待发放',
    '标的币种': '标的币种',
    '一键报名': '一键报名',
    '选择您感兴趣的项目并报名': '选择您感兴趣的项目并报名',
    '等待释放': '等待释放',
    '等待计算您将获得的代币数量': '等待计算您将获得的代币数量',
    '获得代币': '获得代币',
    '前往现货账户查看获得的代币': '前往现货账户查看获得的代币',
    'locking1': '稳稳定存，收益高，心更安！',
    'locking2': '质押FLOKI赚TOKEN',
    '立即登录': '立即登录',
    '项目名': '项目名',
    '年化收益率': '年化收益率',
    '结算日期': '结算日期',
    '锁仓天数': '锁仓天数',
    '锁仓进度': '锁仓进度',
    '天': '天',
    '我要支付': '我要支付',
    '我将收到': '我将收到',
    '购买数字货币': '购买数字货币',
    'btc1': '本頁面顯示了數字貨幣與法幣的實時匯率，通過LBank，您可以將100多種熱門數字貨幣轉換為您所需要的法幣。還可以將您喜歡的法幣轉換為可用的數字貨幣資產。',
    'btc2': '前50款數字貨幣與法幣兌換率',
    '展开': '展开',
    '收起': '收起',
    '数字货币': '数字货币',
    '轻松跟单': '轻松跟单，智能交易',
    '顶级带单员': '顶级带单员',
    '全部带单员': '全部带单员',
    '最高收益率': '最高收益率',
    '获得最高收益率的带单员': '获得最高收益率的带单员',
    '今日最佳': '今日最佳',
    '最高收益': '最高收益',
    '赚取最高带单收益的带单员': '赚取最高带单收益的带单员',
    '新晋带单员': '新晋带单员',
    '最低回撤': '最低回撤',
    '交易风险最稳定的带单员': '交易风险最稳定的带单员',
    '最高跟随者收益': '最高跟随者收益',
    '带领跟随者获得最高收益的带单员': '带领跟随者获得最高收益的带单员',
    '综合排名': '综合排名',
    '收益率': '收益率',
    '胜率': '胜率',
    '收益': '收益',
    '跟随者收益': '跟随者收益',
    '最大回撤': '最大回撤',
    '筛选': '筛选',
    '隐藏满员': '隐藏满员',
    '更多': '更多',
    '跟单': '跟单',
    '空位提醒': '空位提醒',
    '成为带单员': '成为带单员',
    '跟单教程': '跟单教程',
    '跟单周动态': '跟单周动态',
    '明星带单员': '明星带单员',
    '产品更新与热门活动一览': '产品更新与热门活动一览',
    '火箭团团长': '火箭团团长',
    '总收益': '总收益',
    'copy1': '过去7天内表现最佳的带单员榜单',
    'copy2': '高收益、低回撤的新晋带单员',
    'help1': '什么是资产冻结？',
    'help2': '资产冻结是指您在进行某项交易时，流程还未全部完成，当前资产暂时被系统管理，无法供您自由使用，并不代表您的资产丢失或资产出现异常，请您放心。',
    'help3': '期货交易的规则是什么？',
    'help4': '通过预估当前交易对的下一步价格走势（上涨或者下跌）来参与交易。结算时不计算涨幅或者跌幅，只计算涨幅或者跌幅的盈利。不同交割时间结算的盈利百分比不同，盈利会准确显示在交易界面上。',
    'help5': '资产充值、提现需要转换的USDT数量，如何转换？',
    'help6': '资产充值、提现的金额会随着您充值、提现使用的币种/USDT的实时价格波动而变化，其实您的资产并没有发生变化。',
    'help7': '忘记交易密码怎么办？',
    'help8': '如果您忘记了交易密码，可以通过【个人中心】右上角点击【安全中心】【交易密码】进行修改，具体步骤如下：',
    'help9': '1.若绑定了手机号，需获取手机号验证码',
    'help10': '2.若绑定了邮箱，需获取邮箱验证码',
    'help11': '3.填写新的交易密码',
    'help12': '4.确认新的交易密码',
    'help13': '5.点击【提交】',
    'help14': '忘记登录密码怎么办？',
    'help15': '若您忘记登录密码，您可以前往【登录页面】【忘记密码？】获取邮箱或手机验证码，设置新的登录密码。',
    'help16': '如何加强账户安全？',
    'help17': '为您的帐户创建更复杂、更安全的密码，并且不要与任何人分享您的个人信息。',
    'protocol1': '本网站是专门从事外汇及数字资产交易及相关服务的平台（以下简称“本服务”或“服务”）。为本协议之方便，本网站在本协议中使用“我们”或其他第一人称术语。为本协议之方便，下文使用“您”或其他第二人称术语。为本协议之方便，我们和您在本协议中合称为“双方”，我们或您单独称为“一方”。',
    'protocol2': '重要提示：',
    'protocol3': '我们在此特别提醒您：',
    'protocol4': '数字资产本身不由任何金融机构或公司或本网站发行；',
    'protocol5': '数字资产市场是新兴的、未经确认的、可能不会增长的；',
    'protocol6': '数字资产主要被投机者使用，在零售和商业市场使用相对较少。它们全天交易，没有涨跌限制，价格易受庄家和全球政府政策影响而波动较大；',
    'protocol7': '数字资产交易具有极大的风险，并不适合大多数人。您理解并明白此项交易可能导致部分或全部损失，因此您应根据您能承受的损失程度确定交易金额。在作出任何买卖数字资产的决定前，您应仔细考虑并使用清晰的判断来评估您的财务状况和上述风险，并承担由此产生的全部损失。我们对此不承担任何责任。',
    'protocol8': '向您发出通知：',
    'protocol9': '您理解本网站仅是您获取数字资产信息、寻找交易方、就数字资产进行谈判和交易的场所。',
    'protocol10': '使用基于互联网的交易系统也存在风险，包括但不限于软件、硬件和互联网连接故障。由于我们无法控制互联网的可靠性和可用性，因此我们不对失真、延迟和连接故障承担任何责任。',
    'protocol11': '一、总则',
    'protocol12': '《用户协议》（以下简称“本协议”或“本条款”）由正文、《隐私条款》、《了解你的客户及反洗钱政策》以及本网站已经发布或将来可能发布的各类规则、声明、说明等组成。',
    'protocol13': '您在使用本网站提供的服务前，应当仔细阅读本协议。如果您不同意本协议及/或其随时修改，请立即停止使用本网站提供的服务或停止登录本网站。一旦您登录本网站、使用本网站任何服务或其他任何类似行为，即表示您已了解并完全同意本协议的所有内容，包括本网站随时对本协议所做的任何修改。',
    'protocol14': '成为本网站会员后，您将获得一个会员账号及相应的密码，您有责任妥善保管该账号及密码；您应对您账号下进行的所有活动和事件承担法律责任。',
    'protocol15': '通过注册和使用本网站提供的任何服务和功能，您将被视为已阅读、理解并：',
    'protocol16': '接受本协议所有条款和条件。',
    'protocol17': '您确认您已年满18周岁或根据不同适用法律具有订立合同的法定年龄。',
    'protocol18': '您保证交易所涉及的数字资产是合法获得和拥有的。',
    'protocol19': '您同意对您自身的交易或非交易行为以及任何收益或损失承担全部责任。',
    'protocol20': '您确认在注册时提供的信息真实准确。',
    'protocol21': '二、协议修订',
    'protocol22': '我们保留随时修改本协议并在网站上公告的权利，而无需单独通知您。',
    'protocol23': '三、注册',
    'protocol24': '注册资格',
    'protocol25': '您确认并承诺，在您完成注册程序或以本网站允许的其他方式实际使用本网站提供的服务时，您应当是具有可适用法律规定可签署本协议并使用本网站服务能力的自然人、法人或其他组织。一旦您点击“同意注册”按钮，即表示您或您的授权代理人已经同意本协议内容，并将代表您注册并使用本网站服务。',
    'protocol26': '注册目的',
    'protocol27': '您确认并承诺，您在本网站的注册不是为了违反法律法规或扰乱本网站数字资产交易秩序。',
    'protocol28': '注册流程',
    'protocol29': '您同意在本网站提供有效的电子邮箱、手机号码等信息，并同意在本网站注册并使用本网站服务。按照本网站用户注册页面的要求进行操作。您可以使用您提供或确认的电子邮箱、手机号码或本网站允许的其他方式作为登录方式进入本网站。您应对该等信息的真实性、完整性和准确性负责，并承担因此产生的任何直接或间接的损失及不利后果。',
    'protocol30': '您合法、完整、有效地提供注册所需信息并经核实后，有权获得本网站账号和密码。当您获得本网站账号和密码时，即视为您已注册成功，可以登录本网站。',
    'protocol31': '您同意接收本网站发送的与本网站管理、运营相关的电子邮件和/或短信。',
    'protocol32': '四、服务',
    'protocol33': '本网站仅为您通过本网站进行数字资产交易活动提供网络交易平台服务。',
    'protocol34': '服务内容',
    'protocol35': '您有权在本网站浏览各类数字资产产品的实时行情及交易信息，并有权通过本网站提交数字资产交易指令、完成数字资产交易。',
    'protocol36': '服务规则 您承诺遵守本网站以下服务规则：',
    'protocol37': '您应当遵守法律、法规、规章及政策要求的规定，包括但不限于发送或接收任何违法、非法或侵犯他人权利的信息，发送或接收传销材料或其他有害信息或言论，未经本网站授权使用或伪造本网站电子邮件信头信息等。',
    'protocol38': '您应当遵守法律法规，妥善使用和保管您的账号及登录密码、资金密码、您注册时绑定的手机号码、手机收到的手机验证码等。您应对使用您的账户及登录密码、资金密码、手机验证码进行的任何操作及后果承担全部责任。当您发现您的本网站账户、登录密码、资金密码、验证码被第三方未经授权使用，或存在其他账户安全问题时，您应立即有效通知本网站，要求本网站暂停本网站账户的服务。',
    'protocol39': '您在本网站进行数字资产交易时，不得恶意干扰数字资产交易的正常进行、扰乱交易秩序；不得以任何技术手段或其他方式干扰本网站的正常运行或干扰其他用户使用本网站服务；不得以虚构事实等方式恶意诋毁本网站声誉。',
    'protocol40': '产品规则',
    'protocol41': '浏览交易信息',
    'protocol42': '您在本网站浏览交易信息时，应当仔细阅读交易信息中包含的所有内容，包括但不限于价格、委托量、手续费、买入或卖出方向等。您完全接受交易信息中包含的所有内容后，方可点击按钮进行交易。',
    'protocol43': '提交订单',
    'protocol44': '浏览交易信息并确认无误后，您即可提交交易订单。',
    'protocol45': '查看交易详情',
    'protocol46': '您可以通过您的账户查看相应的交易记录。',
    'protocol47': '五、本网站的权利与义务',
    'protocol48': '如您不具备本协议约定的注册资格，本网站有权拒绝您的注册，本网站保留向您或您的授权代理人追究责任的权利。同时，本网站保留在其他任何情况下决定是否接受您的注册的权利。',
    'protocol49': '如本网站发现账户使用者并非账户原始注册人，有权暂停或终止账户的使用。',
    'protocol50': '如本网站发现本网站展示的任何信息有明显错误，本网站有权更正信息。',
    'protocol51': '本网站保留随时修改、中止或终止本网站服务的权利。本网站行使修改或中止服务的权利时，无须事先通知您。本网站终止本网站一项或多项服务，自本网站在网站上发布终止公告之日起生效。',
    'protocol52': '六、责任限制及免责条款',
    'protocol53': '您理解并同意，在任何情况下，我们不对以下事项承担责任：',
    'protocol54': 'Lo收入损失；',
    'protocol55': '交易利润或合约损失；',
    'protocol56': '业务中断造成的损失；',
    'protocol57': '数据损坏或丢失；',
    'protocol58': '您理解并同意，我们不对因下列任一情形给您造成的任何损失承担责任：',
    'protocol59': '您的具体交易可能涉及重大违法或违约行为。',
    'protocol60': '您在本网站的行为涉嫌违法或不道德。',
    'protocol61': '任何其他非因我们原因导致的与本网站提供的服务有关的损失。',
    'protocol62': '第七、协议终止',
    'protocol63': '本网站有权依据本协议的规定终止本网站全部服务，本协议于本网站全部服务终止之日终止。',
    'protocol64': '本协议终止后，您无权要求本网站继续向其提供任何服务或履行任何其他义务，包括但不限于要求本网站向您保留或披露其原网站账户中的任何信息、向您或第三方转发任何其未曾阅读或发送过的信息等。',
    'protocol65': '本协议的终止，不影响守约方要求违约方承担其他责任的义务。',
    'protocol66': '八、信息保护',
    'protocol67': '本网站另行公布的隐私条款的规定为准。',
    'privacy1': '我们致力于保护您的数据',
    'privacy2': '欢迎阅读我们的隐私声明',
    'privacy3': '我们创建此页面是为了帮助您了解我们的隐私计划的关键方面，并了解有关您的隐私权利的更多信息。',
    'privacy4': '在 Crocodile，我们致力于保护您的隐私和数据。您的个人信息安全对我们至关重要，我们遵循严格的内部准则、法律要求和行业最佳实践，以确保您的数据安全且仅用于授权目的。',
    'privacy5': 'Crocodile 的隐私原则',
    'privacy6': '始终保持透明',
    'privacy7': '我们对透明度的承诺意味着我们将随时向您通报您的数据的使用和共享方式。我们将定期更新此门户和我们的隐私声明，以确保您始终了解可能影响您的任何更改。这有助于我们让您对您的数据和隐私做出明智的决定。',
    'privacy8': '问责制和合规性',
    'privacy9': '我们认真对待我们的隐私责任。我们的做法完全符合世界各地适用的数据保护法律和法规。我们定期进行审核并不断改进我们的流程，以确保我们遵守最高的数据保护和隐私标准。我们的计划已在我们运营的多个司法管辖区获得了令人垂涎的安全和隐私认证。',
    'privacy10': '数据安全',
    'privacy11': '我们优先考虑您的隐私和安全，实施强有力的措施保护您的数据免遭丢失、滥用或未经授权的访问，同时严格控制内部访问。我们的高级加密和严格协议（包括身份验证）可维护您数据的机密性和完整性。',
    'privacy12': '数据最小化和目的限制',
    'privacy13': '我们已实施强大的数据最小化治理控制，以确保 Crocodile 提供的所有产品和服务仅出于特定目的收集用户数据。我们在隐私声明中描述了 Crocodile 数据收集的具体合法商业目的。',
    'privacy14': '用户权利和访问',
    'privacy15': '我们承认并维护您对个人数据的基本权利。为了帮助您行使这些权利，我们在 Crocodile 应用程序中以及通过专用网络表单提供了易于使用的工具和机制，您可以在此向我们请求支持。有关您所在司法管辖区适用权利的更多信息，请查看以下链接中的隐私声明。如果您想行使您的权利，请阅读本页的“行使您的隐私权”部分。',
    'privacy16': '设计隐私',
    'privacy17': '我们制定了严格的流程，以确保隐私和数据保护融入我们所有的产品和服务中。我们专门的隐私团队与开发人员密切合作，以符合全球标准和法规的方式整合数据保护设计和默认设置。',
    'privacy18': '本隐私声明适用于我们在 Crocodile 平台、网站和部门上开展的所有个人数据处理活动。',
    'privacy19': '如果您是我们服务的客户或用户，则本隐私声明适用，包括但不限于我们与您达成的任何协议。',
    'privacy20': '如果您不是我们服务的相关利益相关者、客户或用户，但正在使用我们的网站，则本隐私声明也适用于您。',
    'other1': '关于Crocodile',
    'other2': 'Crocodile隐私政策',
    'other3': 'Crocodile简介',
    'other4': '7个月前',
    '语言': '语言',
    'question1': '为什么选择Crocodile Exchange?',
    'answer1': 'Crocodile Exchange 于2021年成立于加拿大，并在美国财政部（FinCEN）监管并颁发MSB（Money Services Business）牌照。',
    'question2': '我如何注册账户？需要提供哪些资料？',
    'answer2': '您只需使用手机号即可注册账户。注册后，需完成KYC（身份认证），包括上传身份证明文件或驾驶执照，以确保账户安全。',
    'question3': '是否有推荐奖励？我如何邀请朋友？',
    'answer3': '每位用户均有专属邀请码。成功邀请好友注册并完成首笔交易后，您将获得推荐佣金奖励，佣金可实时提现，无需等待。',
    'question4': '平台如何保障我的资金安全？',
    'answer4': '我们采用多重冷钱包+热钱包分离机制，用户资产绝大多数储存在离线冷钱包中。同时，平台设有多重签名机制与实时风控系统，确保资金安全无虞。',
    "下载App": "下载App",
    "扫描并下载": "扫描并下载",
    "全球": "全球",
    "顶尖": "顶尖",
    "加密货币": "加密货币",
    "交易平台": "交易平台",
    "使用美元买入Bitcoin、Ethereum和多种加密货币": "使用美元买入Bitcoin、Ethereum和多种加密货币",
    "通过加密货币、电汇等多种方式存入资金*": "通过加密货币、电汇等多种方式存入资金*",
    "業界領先的法遵與資安認證": "業界領先的法遵與資安認證",
    "深受全球 1 億以上用戶信賴": "深受全球 1 億以上用戶信賴",
}
